import { useContext } from 'react';
import { DoctorWorkspaceContext } from '../components/doctor/doctorWorkspaceContext';
import { NurseWorkspaceContext } from '../components/nurse/nurseWorkspaceContext';

export function useCatalogToast(toastProp) {
  const nurse = useContext(NurseWorkspaceContext);
  const doctor = useContext(DoctorWorkspaceContext);
  const toast = toastProp ?? nurse?.toast ?? doctor?.toast;

  if (!toast) {
    throw new Error(
      'useCatalogToast : contexte portal requis (MajorLayout, NurseLayout ou DoctorLayout).'
    );
  }

  return toast;
}
